import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translation from "../../../../shared/Translation";

class NameOnTicket extends Component {
    render() {
        return  <div className="input__question">
                    <div className="input__top">
                        <label className="input__label question__label" for={`name_on_ticket_${this.props.id}`}>
                          <Translation>{this.props.isBundle ? 'checkout__name_printed_on_bundle' : 'checkout__name_printed_on_ticket'}</Translation>
                        </label>
                        <span className="input__required"><Translation>{"checkout__required"}</Translation></span>
                    </div>
                    <div className="input input--inset">
                        <input
                            id={`name_on_ticket_${this.props.id}`}
                            value={this.props.value}
                            className="input__control"
                            type="text"
                            name="text_name"
                            onChange={this.props.onChange}
                            placeholder="Full Name"
                            onFocus={this.props.onFocus}
                        />
                    </div>
                    
                </div>
    }
}

NameOnTicket.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    isBundle: PropTypes.bool,
    onFocus: PropTypes.func,
}

export default NameOnTicket
